import { stringify } from 'qs';
import request from '@/utils/request';

export async function queryPortals() {
  return request('/portals');
}

export async function queryEnabled() {
  return request('/email/enabled');
}

export async function queryUsers(params) {
  const newParam = {};
  Object.keys(params).forEach(key => {
    if (key !== 'firstLoad') newParam[key] = params[key];
  });
  return request(`/users?${stringify(newParam)}`);
}

export async function queryUsersHistory(params) {
  return request(`/users/history?${stringify(params)}`);
}

export async function queryUsersComponent(param) {
  return request(`/users/${param.userId}/components`);
}

export async function queryComponentsByMenu(param) {
  return request(`/users/${param.userId}/menus/${param.privId}/components`);
}

// 新增/编辑用户
export async function editUser(params, method = 'POST') {
  return request('/users', {
    method,
    body: {
      ...params,
    },
  });
}

// 重置密码
export async function resetPwd(userId) {
  return request(`/users/${userId}/pwd`, {
    method: 'PATCH',
  });
}

// 锁定
export async function lockUser(userId) {
  return request(`/users/${userId}/lock`, {
    method: 'PATCH',
  });
}

// 解锁
export async function unLockUser(userId) {
  return request(`/users/${userId}/unLock`, {
    method: 'PATCH',
  });
}

// 禁用
export async function disableUser(userId) {
  return request(`/users/${userId}/disable`, {
    method: 'PATCH',
  });
}

// 启用
export async function enableUser(userId) {
  return request(`/users/${userId}/enable`, {
    method: 'PATCH',
  });
}

// 更改用户菜单权限
export async function changeUserMenu(userId, param, method = 'POST') {
  return request(`/users/${userId}/privs/new`, {
    method,
    body: param,
  });
}

export async function setFavorites(param, method) {
  return request('/favorites', {
    method,
    body: param,
  });
}

export async function queryUserFavouritMenu(param) {
  return request(`/portals/${param.portalId}/user/${param.userId}/favorites`);
}

export async function queryAllUsers() {
  return request('/users/');
}

export async function checkUserCode(code) {
  return request(`/users/checkUserCode?userCode=${code}`);
}
